import React from 'react';
import { ToastContainer } from 'react-toastify';
import AdminChrome from '../../AdminShared/AdminChrome';
import TicketHistory from '../components/TicketHistory';

const TicketHistoryApp = ({ chrome = {}, ...props }) => (
  <AdminChrome {...chrome}>
    <div className="adash-body">
      <TicketHistory {...props} />
    </div>
    <ToastContainer icon={false} />
  </AdminChrome>
);

export default TicketHistoryApp;
